import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  title: string;
  id: number;
  zone: string;
  zoneLevelId: number;
  zoneLevel: string;
  categoryId: number;
  categoryKey: string;
  image: string;
  field_outlet_image_desc_en: string;
  field_outlet_image_desc_ms: string;
  field_outlet_image_desc_zh: string;
  field_product_name_en: string;
  field_product_name_ms: string;
  field_product_name_zh: string;
  category: string;
  field_shop_store_hour_value_en: string;
  field_shop_store_hour_value_ms: string;
  field_shop_store_hour_value_zh: string;
  field_shop_location_value_en: string;
  field_shop_location_value_ms: string;
  field_shop_location_value_zh: string;
  type: string;
  airport: string;
  published: boolean;
  item_count: number;
  created_at: string;
  updated_at: string;
}

export interface DocumentDetailsResponseHeading {
  id: string;
  title: string;
  field_page_banner_image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_page_description_en: string;
  field_page_description_ms: string;
  field_page_description_zh: string;
}

const fetchLandingHeadingDetails = async (airport: string | null): Promise<DocumentDetailsResponseHeading> => {
  if (!airport) throw new Error("Airport not found");
  const response = await axios.get(
    `${centralizedHost}/api/page-headers/all-fields?pageName=shop-dine-services/services&airport=${airport}`
  );
  console.log(response.data[0], "tested");
  return response.data[0];
};

const useLandingHeadingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponseHeading, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponseHeading, DefaultError> => {
  const [currentAirport] = useLocalStorage("currentAirport", null);
  return useQuery<DocumentDetailsResponseHeading, DefaultError>(
    {
      queryKey: ["FlightHeadingDocumentDetails", id, currentAirport],
      enabled: !!id && !!currentAirport,
      queryFn: () => fetchLandingHeadingDetails(currentAirport),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

// edit api call
const fetchLandingPageContentDetails = async (parent_term_id: string): Promise<any> => {
  if (!parent_term_id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/en-gb/api/shop-dine-services/get-by-id/${parent_term_id}`);

  return response?.data?.[0];
};

const useLandingPageContenDocumentDetails = (
  parent_term_id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["landingPageContenDetails", parent_term_id],
      enabled: false,
      queryFn: () => {
        return fetchLandingPageContentDetails(parent_term_id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useLandingHeadingDocumentDetails, useLandingPageContenDocumentDetails };
